if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        // document.querySelectorAll('.product__media-item').forEach((video) => {

        //   const currentSlide = event.detail.currentElement;

        //   console.log('hii video');
        //   if (currentSlide.contains(video)) {
        //     return;
        //   }

        //   console.log('hii video');

        //   video.pause();
        //   video.currentTime = 0;

        //   const deferredMedia = video.closest('.deferred-media');

        //   if (deferredMedia) {

        //     deferredMedia.removeAttribute('loaded');

        //     const poster = deferredMedia.querySelector('.deferred-media__poster');

        //     if (poster) {
        //       poster.removeAttribute('hidden');
        //       poster.style.display = 'block';
        //     }
        //   }

        // });

        document.querySelectorAll('.product__media-item').forEach((slide) => {
          slide.classList.remove('is-active');
          const currentSlide = event.detail.currentElement;
          // console.log('currentSlide',currentSlide);
          const media_id = currentSlide.getAttribute('data-media-id');
          const slide_media_id = slide.getAttribute('data-media-id');

          // console.log('media_id',media_id);
          // console.log('slide_media_id',slide_media_id);
          if(slide_media_id == media_id){
            // console.log('match')
            slide.classList.add('is-active');
              const video = currentSlide.querySelector('video');
              if (video) {
                // console.log('have video')
                // video.controls = false;
                // video.loop = 'loop';
                if(!video.paused){
                  // console.log('hiii play')
                  slide.classList.add('is-active');
                  video.play();
                } 

                if(video.paused){
                  slide.classList.remove('is-active');
                }
              }else{
                slide.classList.remove('is-active');
              }
          }else{
              const video = slide.querySelector('video'); 
              if (video) {
                video.controls = false;
                video.loop = 'loop';
                video.pause();
                video.currentTime = 0;
              }
          }

          // if(slide_media_id != media_id){
          //   const videoElement = currentSlide.querySelector('video');
          //   if(videoElement){
          //     console.log('get')
          //      videoElement.pause();   
          //       videoElement.currentTime = 0;
          //   }
          // }

        });

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        // console.log('event.detail.currentElement.dataset.mediaId',event.detail.currentElement.dataset.mediaId);
        const activeButton = document.querySelector('.thumbnail-list__item[data-target="'+event.detail.currentElement.dataset.mediaId+'"] button')
        if(activeButton){              
            activeButton.setAttribute('aria-current', true);
        }
      }

      //  onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(
      //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //   );
      //   this.setActiveThumbnail(thumbnail);
      // }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        // if (deferredMedia) {
        //   deferredMedia.loadContent(false).then(() => {
        //     const videoElement = activeItem.querySelector('video');
        //     if (videoElement) {
        //       videoElement.setAttribute('playsinline', ''); // Ensure inline playback on iOS
        //       videoElement.setAttribute('muted', ''); // Autoplay restriction workaround
        //       if (videoElement.readyState >= 3) {
        //         videoElement.play().catch((error) => {
        //           console.error('Error playing video:', error);
        //         });
        //       } else {
        //         videoElement.addEventListener('canplay', () => {
        //           videoElement.play().catch((error) => {
        //             console.error('Error playing video after canplay event:', error);
        //           });
        //         });
        //       }
        //     }
        //   });
        // }
        if (deferredMedia) {
          deferredMedia.loadContent(false);

          const videoElement = activeItem.querySelector('video');

          if (videoElement) {
            videoElement.setAttribute('playsinline', '');
            videoElement.setAttribute('muted', '');

            if (videoElement.readyState >= 3) {
              videoElement.play().catch(console.error);
            } else {
              videoElement.addEventListener(
                'canplay',
                () => {
                  videoElement.play().catch(console.error);
                },
                { once: true }
              );
            }
          }
        }
         else {
          const videoElement = activeItem.querySelector('video');
          if (videoElement) {
            videoElement.setAttribute('playsinline', ''); // Ensure inline playback on iOS
            videoElement.setAttribute('muted', ''); // Autoplay restriction workaround
            if (videoElement.readyState >= 3) {
              videoElement.play().catch((error) => {
                console.error('Error playing video:', error);
              });
            } else {
              videoElement.addEventListener('canplay', () => {
                videoElement.play().catch((error) => {
                  console.error('Error playing video after canplay event:', error);
                });
              });
            }
          }
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
